import type IMethodosRepository from '@/core/domain/emethodos/IMethodosRepository.ts'
import type { EMethodosInput } from '@/core/domain/emethodos/EMethodos.ts'

export default class UpdateEMethodosUseCase {
  private readonly eMethodosRepository: IMethodosRepository

  constructor(eMethodosRepository: IMethodosRepository) {
    this.eMethodosRepository = eMethodosRepository
  }

  async execute(input: EMethodosInput) {
    return this.eMethodosRepository.updateEMethodos(input)
  }
}
